export enum EStatusProcessamento {
  EmDigitacao = 1,
  AguardandoIntegracao = 2,
  Integrado = 3,
  Cancelado = 4,
}
